//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: String,
    rightTitle: { type: String, default: "同比" },
    count: String,
    countColor: { type: String, default: "#333" },
    bar: String,
    barWidth: String,
    row2: {type: Boolean, default: false}
  },
};
